var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"list-group"},_vm._l((_vm.config.filters.saved),function(item){return _c('li',{staticClass:"list-group-item pointer",on:{"click":function($event){return _vm.setFilter(item)}}},[_vm._v(_vm._s(item.name))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }